<template>
    <div class="form-sample">
        <b-modal v-model="isVisible" hide-footer class="pt-8" header-class="p-0" content-class="custom-model-wrap">
            <template #modal-title="{ cancel }">
                <div class="title-block text-center p-2">{{ $translate('uploaded_file') }}</div>
                <div class="close-btn" @click="cancel()">×</div>
            </template>
            <b-img :src="model && model.url" v-if="['jpg', 'jpeg', 'png'].includes(model && model.file_extension)" fluid
                alt="Responsive image"></b-img>
            <a v-else-if="['xls', 'xlsx'].includes(
                model && model.file_extension
            )
                " :href="model && model.url">
                <div class="btn btn-success btn-sm">
                    <i class="fa-solid fa-file-excel fa-2x"></i>
                </div>
            </a>
            <video v-else-if="['mp4'].includes(
                model && model.file_extension
            )
                " width="50%" height="50%" controls>
                <source :src="model.url" type="video/mp4">
            </video>
            <a v-else-if="model && model.file_extension == 'pdf'" :href="model && model.url">
                <div class="btn delete-button btn-sm">
                    <i class="fa-solid fa-file-pdf fa-2x"></i>
                </div>
            </a>
            <a v-else :href="model && model.url">
                <div class="btn btn-success btn-sm">
                    <i class="fa-solid fa-file fa-2x"></i>
                </div>
            </a>
            <br />
            <div class="row px-3">
                <b-list-group class="mt-2 col-12 col-sm-9">
                    <b-list-group-item class="d-inline-flex p-2">
                        <b-form-input :placeholder="$translate('file_name_placeholder')" v-model="model.name" required v-custom-validation="$textRequired()"/>
                        <span class="d-inline-flex align-items-center text-muted ml-1 mr-3">.{{ model.file_extension
                        }}</span>
                    </b-list-group-item>
                </b-list-group>
                <b-col cols="12" sm="3" class="align-self-center pt-2">
                    <b-button type="submit" variant="info" class="btn-fw" @click="renameFileName(model.index, model.name)">
                        {{ $translate('rename') }}
                    </b-button>
                </b-col>
            </div>
            <div class="text-center">
                <b-button variant="delete-button" size="fw" class="mt-2" @click="deleteAttachment(model.id)">{{
                    $deleteLabel() }}</b-button>
            </div>
        </b-modal>

        <!-- <b-row>
            <b-col cols="4">
                <b-form-file id="uploadData" @change="uploadFile"></b-form-file>
            </b-col>
        </b-row> -->
        <b-modal v-model="showModal" id="add-attachments-modal" centered header-class="p-0"
            footer-class="d-flex justify-content-center border-0" content-class="custom-model-wrap" hide-footer
            title="File(s) Upload">
            <template #modal-title="{ cancel }">
                <div class="text-center">
                    <div class="title-block text-center p-2">{{ $translate('files_upload') }}</div>
                    <div class="close-btn" @click="cancel()">×</div>
                </div>
            </template>
            <b-row>
                <b-col sm="12" xl="8" v-if="this.filelist.length" v-cloak>
                    <!--show a list of the selected files, with an input to (optionally) rename the file before upload-->
                    <b-list-group>
                        <b-list-group-item class="d-inline-flex p-2" v-for="(file, i) in filelist" :key="i">
                            <!--file name input to rename the file before upload-->
                            <b-form-input placeholder="File name..." v-model="filelist[i].fileName" required v-custom-validation="$textRequired()"
                                @change="renameFile(i, filelist[i].fileName)" />

                            <!--file extension-->
                            <span class="d-inline-flex align-items-center text-muted ml-1 mr-3">.{{ filelist[i].extension
                            }}</span>

                            <!--remove file from list (and from upload)-->
                            <b-button variant="outline-danger" size="sm" @click="remove(filelist.indexOf(file))">
                                <b-icon-trash></b-icon-trash>
                            </b-button>
                        </b-list-group-item>
                    </b-list-group>
                </b-col>

                <!--this column contains the file drop area-->
                <!--its width is automatically set based on existance of the file list column and breakpoint-->
                <b-col class="file-drop-column my-4 my-xl-0 p-0">
                    <div class="file-drop-area bg-light" @dragover="dragover" @drop="drop">
                        <!--we need an actual file input in order to have the drag&drop functionality-->
                        <!--and the File object(s) containing the files dropped-->
                        <!--We keep it invisible because we want to display something different than a file input-->
                        <input type="file" name="file-input" id="file-input" class="file-input invisible"
                            @change="onChange" />

                        <!--clicking on this label will trigger the clicked event on the file input-->
                        <!--this will cause the 'choose file' system dialog-->
                        <label for="file-input" class="w-100 text-center cursor-pointer text-muted m-0 px-3 py-5">
                            <p>
                                <b-icon-cloud-upload-fill font-scale="3"></b-icon-cloud-upload-fill>
                            </p>
                            <div>
                                <p class="mb-0">{{ $translate('upload_file_note') }}</p>
                                <p class="mb-0">
                                    <span class="text-info">{{ $translate('select_from_computer') }}</span>
                                </p>
                            </div>
                        </label>
                    </div>
                </b-col>
            </b-row>

            <div class="text-center mt-4">
                <b-button variant="info" @click="$bvModal.hide('add-attachments-modal')" size="fw" class="me-2">
                    {{ $cancelLabel() }}
                </b-button>
                <b-button type="submit" :disabled="!filelist.length" variant="info" size="fw" @click="onSubmit()">
                    {{ $translate('upload_files') }}
                </b-button>
            </div>
        </b-modal>
        <b-row class="align-items-center">
            <!-- <b-col cols="4">
                <b-button variant="primary" @click="showModal = !showModal">
                    Upload Attachment(s)
                </b-button>
            </b-col> -->
            <b-col cols="12" md="10" class="mb-3">
                <b-container fluid class="p-1 mt-4 form-control">
                    <b-row class="attachment">
                        <b-col v-for="(item, index) in cleanedAttachments" :key="index" md="2" class="mt-2 mt-md-0">
                            <button v-if="['jpg', 'jpeg', 'png'].includes(
                                item.file_extension
                            )" @click="setModel(item, index)">
                                <b-img :height="imageHeight" :width="imageWidth" :src="item.url" alt="Image 1"></b-img>
                            </button>
                            <button v-else-if="['xls', 'xlsx'].includes(
                                item.file_extension
                            )
                                " @click="setModel(item, index)">
                                <div class="btn btn-success btn-sm">
                                    <i class="fa-solid fa-file-excel fa-2x"></i>
                                </div>
                            </button>
                            <button v-else-if="['mp4'].includes(
                                item.file_extension
                            )
                                " @click="setModel(item, index)">
                                <div class="btn btn-dark btn-sm">
                                    <i class="fa-solid fa-play"></i>
                                </div>
                            </button>
                            <button v-else-if="item.file_extension == 'pdf'" @click="setModel(item, index)">
                                <div class="btn delete-button btn-sm">
                                    <i class="fa-solid fa-file-pdf fa-2x"></i>
                                </div>
                            </button>
                            <button v-else @click="setModel(item, index)">
                                <div class="btn btn-success btn-sm">
                                    <i class="fa fa-file fa-2x"></i>
                                </div>
                            </button>
                            <div>
                                <label>{{ item.name ? item.name + '.' + item.file_extension : '' }}</label><br>
                                <div class="mt-1 mb-2" v-if="item.updated_at">
                                    <label><b>{{ $translate('upload_on') }}</b></label>
                                    <label>{{ item.created_at | displayTime }}</label>
                                </div>
                            </div>
                        </b-col>
                        <b-col v-if="!cleanedAttachments.length">
                            <h4 class="text-black">{{ $translate('no_attachments_submitted') }}</h4>
                        </b-col>
                    </b-row>
                </b-container>
            </b-col>
            <b-col cols="12" md="2">
                <b-button variant="info" @click="showModal = !showModal">
                    {{ $translate('upload_files') }}
                </b-button>
            </b-col>
        </b-row>
    </div>
</template>

<script>
import popupMixins from '@/mixins/popupMixins'
import locationMixins from '@/mixins/locationMixins'


export default {
    name: 'attachments',

    mixins: [popupMixins, locationMixins],
    props: {
        order: {
            type: Object,
        },
    },
    data() {
        return {
            imageHeight: 60,
            imageWidth: 60,
            submitting: false,
            model: {
                name: null
            },
            isVisible: false,
            filelist: [],
            // attachment: null,
            // Controls Filepicker modal
            showModal: false,
        }
    },
    computed: {
        componentName() {
            return this.$translate('service_attachment')
        },
        cleanedAttachments() {
            return ((this.order && this.order.attachments) ||[])          
        },
        mediaBaseUrl() {
            return this.$store.getters['mediaBaseUrl']
        },
    },
    mounted() {
        this.$store.dispatch('js_report/fetchCredentials')
    },
    filters: {
        displayTime(date) {
            const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone
            console.log('timezone', timezone)
            if (date) {
                return new Date(date).toLocaleString('en-US', {
                    timeZone: timezone,
                })
            } else {
                return ''
            }
        },

    },
    methods: {
        onSubmit() {
            event.preventDefault()

            console.log(this.filelist)
            this.uploadFile()
        },

        setModel(item, i) {
            this.model = { ...item, index: i }
            for (const key in item) {
                this.$set(this.model, key, item[key])
            }
            this.isVisible = true
        },
        renameFileName(fileIndex, newName) {
            const file = this.cleanedAttachments[fileIndex]
            if (!newName) {
                this.doToast(this.$translate('error'), this.$translate('file_name_required'), 'danger')
                return false
            }
            file.name = newName
            if (file.id) {
                this.$store.dispatch('orderAttachmentsStore/updateAttachment', {
                    file,
                })
                this.isVisible = false
            }
        },
        renameFile(fileIndex, newName) {
            const file = this.filelist[fileIndex].file
            var newFile = new File(
                [file],
                `${newName}.${this.filelist[fileIndex].extension}`,
                {
                    type: file.type,
                }
            )

            // Rebuild File Obj for file list array
            const fileName = newFile.name.replace(/\.[^/.]+$/, '') //extract filename (no extension) from the file full name
            const extension = newFile.name.split('.').pop() //extract

            this.filelist[fileIndex] = {
                fileName: fileName,
                extension: extension,
                file: newFile,
            }
        },
        onChange(event) {
            let allowedTypes = this.$allowedTypes
            let uploadedFileName = event.target.files[0].name;
            let fileExtension = uploadedFileName.split('.').pop();
            let maxFileSize = this.$maxFileSize
            console.log("event.target.files", event.target.files)
            if (!allowedTypes.includes(fileExtension.toLowerCase())) {
                this.doToast(this.$translate('error'), this.$translate('invalid_file_type'), 'danger')
                return false;
            }
            if (maxFileSize < event.target.files[0].size) {
                this.doToast(this.$translate('error'), this.$translate('file_size_alert'), 'danger')
                return false
            }
            const fileArray = [...event.target.files] //put the files in a temporary array
            fileArray.forEach(file => {
                const fileName = file.name.replace(/\.[^/.]+$/, '') //extract filename (no extension) from the file full name
                const extension = file.name.split('.').pop() //extract extensionfrom the file fullname
                this.filelist.push({
                    fileName: fileName,
                    extension: extension,
                    file: file,
                }) //store selected files and additional data in our array
            })
        },
        remove(i) {
            this.filelist.splice(i, 1)
        },
        removeAll(i) {
            this.filelist.splice(i, i.length)
        },
        dragover(event) {
            event.preventDefault()
        },
        drop(event) {
            event.preventDefault()
            this.onChange()
        },
        async uploadFile() {
            console.log('upload event', event)
            try {
                this.submitting = true
                const files = this.filelist.map(file => file.file)
                const p = await this.getCurrentLocation()
                console.log('coordinates', p)
                const lat = p.coords.latitude
                const long = p.coords.longitude

                const { keys } = await this.$store.dispatch(
                    's3files/s3upload',
                    files
                )
                let url = [];
                keys.forEach(key => {
                    url.push(`${this.mediaBaseUrl}/${key}`)
                })
                const newFiles = []
                files.forEach((element, i) => {
                    newFiles.push({ "name": element.name.replace(/\.[^/.]+$/, ''), "url": url[i], "file_extension": element.name.split('.').pop(), "lat": lat, "long": long })

                });
                const payload = newFiles
                let order_id = this.order.id

                await this.$store.dispatch(
                    'customerPortal/createAttachment',
                    { order_id, payload }
                )

                this.$store.dispatch('customerPortal/fetchOrder', this.order.id)
                this.genericToast(
                    this.componentName,
                    this.$translate('uploaded'),
                    'success',
                    this.$translate(`attachment_uploaded`)
                )
                // Hide modal after success
                this.showModal = false
                this.removeAll(this.filelist)
                // this.doToast(
                //     'Image Added!',
                //     'Attachment Added!',
                //     'success'
                // )
            } catch (error) {
                console.error('addAttachement', error)

                this.doToast(this.$translate('error'), this.$translate('error_adding_attachment'), 'danger')
            } finally {
                this.submitting = false
            }
        },
        deleteAttachment(id) {
            const title = this.$translate('delete_attachment')
            const message = this.$translate(`delete_attachment_note`)
            this.confirmMessage(title, message).then(result => {
                if (!result) return

                this.submitting = true
                const payload = {
                    order_id: this.order.id,
                    attachment_id: id,
                }

                this.$store
                    .dispatch('customerPortal/deleteAttachment', payload)
                    .then(() => {
                        this.$store.dispatch(
                            'customerPortal/fetchOrder',
                            this.order.id
                        )

                        this.genericToast(
                            this.componentName,
                            this.$translate('deleted'),
                            'success',
                            this.$translate('attachment_deleted')
                        )
                        this.isVisible = false
                    })
                    .catch(error => {
                        console.error(error)

                        this.doToast(
                            this.$translate('error'),
                            this.$translate('attachment_deleted_error'),
                            'danger'
                        )
                    })
                    .finally(() => {
                        this.submitting = false
                    })
            })
        },
    },
}
</script>

<style lang="scss" scoped></style>
